/** Minimal translate fn (i18next TFunction or useSafeTranslation). */
export type LivesTranslate = (key: string, fallback: string) => string;

/** Single generic copy for all insufficient-lives flows (solo quiz, PvP lobby, PvP room). */
export const INSUFFICIENT_LIVES_I18N_KEY = 'lives.insufficientLivesBody';
const INSUFFICIENT_LIVES_FALLBACK_EN = 'You need at least 1 life to continue.';

/** Exact English strings the API may return (any → generic body). */
const SERVER_LIVES_HINTS = [
  'insufficient lives',
  'enough lives',
  'at least 1 life',
  'no lives remaining',
] as const;

export function isInsufficientLivesMessage(raw: string | undefined | null): boolean {
  if (!raw) return false;
  const lower = raw.toLowerCase();
  return SERVER_LIVES_HINTS.some((h) => lower.includes(h));
}

/** Generic insufficient-lives message (same for solo and PvP). */
export function getInsufficientLivesMessage(t: LivesTranslate): string {
  return t(INSUFFICIENT_LIVES_I18N_KEY, INSUFFICIENT_LIVES_FALLBACK_EN);
}

/**
 * Maps any server English lives error to the single generic `lives.insufficientLivesBody`.
 * Non-lives messages are returned unchanged.
 */
export function translateLivesOrRaw(t: LivesTranslate, raw: string): string {
  if (isInsufficientLivesMessage(raw)) {
    return getInsufficientLivesMessage(t);
  }
  return raw;
}
